export default __webpack_public_path__ + "static/media/ice_block.8af4b97a.png";